import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { validateItemsBuy, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import ItemsBuyForm from '../components/ItemsBuyForm';
import validate from '../components/Validations/submitValidationsItemsBuyForm';
const mapStateToProps = (state) => {
    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmit(values, dispatch) {
            dispatch(submitForm());
            let errors = validate(values);
            if( Object.keys(errors).length === 0){
            return dispatch(validateItemsBuy(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint);
                        }
                    });
                }
            });
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemsBuyForm);



/** WEBPACK FOOTER **
 ** ./src/containers/ItemsBuyContainer.js
 **/